{
  "name": "@wert-io/widget-initializer",
  "version": "6.7.1",
  "description": "WertWidget helper",
  "main": "index.js",
  "types": "index.d.ts",
  "repository": {
    "type": "git",
    "url": "https://github.com/wert-io/widget-initializer.git"
  },
  "scripts": {
    "build": "tsc -p .",
    "build-script": "rollup -c",
    "test": "jest --ci --reporters=default --reporters=jest-junit"
  },
  "author": "@wert-io",
  "license": "ISC",
  "devDependencies": {
    "@babel/core": "^7.13.16",
    "@babel/preset-env": "^7.13.15",
    "@rollup/plugin-babel": "^5.3.0",
    "@rollup/plugin-commonjs": "^18.0.0",
    "@rollup/plugin-json": "^4.1.0",
    "@rollup/plugin-node-resolve": "^13.1.3",
    "@typescript-eslint/eslint-plugin": "^4.28.1",
    "@typescript-eslint/parser": "^4.28.1",
    "eslint": "^7.25.0",
    "eslint-plugin-import": "^2.22.1",
    "jest": "^27.0.5",
    "jest-junit": "^12.0.0",
    "rollup": "^2.45.2",
    "typescript": "^4.3.5"
  },
  "dependencies": {},
  "jest": {
    "testEnvironment": "jsdom",
    "transformIgnorePatterns": [
      "node_modules/(?!variables/.*)"
    ]
  },
  "jest-junit": {
    "outputDirectory": "reports",
    "outputName": "jest-junit.xml",
    "ancestorSeparator": " › ",
    "uniqueOutputName": "false",
    "suiteNameTemplate": "{filepath}",
    "classNameTemplate": "{classname}",
    "titleTemplate": "{title}"
  }
}
